// extracted by mini-css-extract-plugin
export var imageBox = "newspageitem-module--image-box--xje6o";
export var newsCard = "newspageitem-module--news-card--yiIIW";
export var newsLink = "newspageitem-module--news-link--mMej3";
export var newsPageText = "newspageitem-module--news-page-text--KPLFo";